<div class="template" [class.selected]="isSelected" (click)="selectTemplate.emit()">
  <div
    class="img"
    [style.background-image]="'url(/assets/images/direct/template-images/' + template.id + '.png)'"></div>
  <div class="details">
    <span [ngClass]="isSelected ? 'text-grass-darker' : 'text-night-lighter'">{{ template.name }}</span>
    <sbnb-icon [ngClass]="{ 'text-grass-darker': isSelected, invisible: !isSelected }" icon="check"></sbnb-icon>
  </div>
</div>
